export default __webpack_public_path__ + "static/media/ragi.446122d9.png";